/* global axios */
import ApiClient from './ApiClient';

export const buildScheduledMessagePayload = ({
  content,
  status,
  scheduled_at,
  scheduledAt,
  template_params,
  templateParams,
  attachment,
  remove_attachment,
  removeAttachment,
  hold_on_reply,
  holdOnReply,
} = {}) => {
  const scheduledAtValue = scheduled_at || scheduledAt;
  const templateParamsValue = template_params || templateParams;
  const removeAttachmentValue = remove_attachment || removeAttachment;
  const holdOnReplyValue = hold_on_reply !== undefined ? hold_on_reply : holdOnReply;

  if (!attachment) {
    return {
      content,
      status,
      scheduled_at: scheduledAtValue,
      template_params: templateParamsValue,
      remove_attachment: removeAttachmentValue || undefined,
      hold_on_reply: holdOnReplyValue,
    };
  }

  const payload = new FormData();
  if (content) payload.append('content', content);
  if (scheduledAtValue) payload.append('scheduled_at', scheduledAtValue);
  if (status) payload.append('status', status);
  payload.append('attachment', attachment);
  if (templateParamsValue) {
    payload.append('template_params', JSON.stringify(templateParamsValue));
  }
  if (holdOnReplyValue !== undefined) {
    payload.append('hold_on_reply', holdOnReplyValue);
  }

  return payload;
};

class ScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`
    );
  }

  create(conversationId, payload) {
    return axios({
      method: 'post',
      url: `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
      data: buildScheduledMessagePayload(payload),
    });
  }

  update(conversationId, scheduledMessageId, payload) {
    return axios({
      method: 'patch',
      url: `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${scheduledMessageId}`,
      data: buildScheduledMessagePayload(payload),
    });
  }

  delete(conversationId, scheduledMessageId) {
    return axios.delete(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${scheduledMessageId}`
    );
  }
}

export default new ScheduledMessagesAPI();